import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bestcabserviceinpune() {



  const cardData = {
"keyword": "Best Cab Service in Pune",

"headingDescription":
  "Shivai Travels is recognized for offering one of the best cab services in Pune with reliable transportation solutions for local travel, airport transfers, corporate rides, outstation trips, family vacations, and daily commuting. We focus on customer comfort, safety, punctuality, and affordable pricing to deliver a smooth and stress-free travel experience. Our professional drivers, clean and well-maintained vehicles, transparent fares, and 24/7 customer support make every journey convenient and dependable. Whether you need a one-way cab, round-trip service, airport pickup, or full-day taxi rental, Shivai Travels provides flexible travel options with sedans, SUVs, and premium cars suitable for all travel needs.",

"topPlaces": [
  {
    "title": "Reliable Local Cab Service in Pune",
    "description": "Best cab service in Pune ensures quick and reliable local travel across the city for office commute, shopping, hospital visits, and daily transportation with professional drivers."
  },
  {
    "title": "24/7 Cab Service in Pune",
    "description": "Round-the-clock cab service in Pune is available for early morning airport trips, late-night pickups, and emergency travel needs with instant booking support."
  },
  {
    "title": "Airport Transfer Cab Pune",
    "description": "Best cab service in Pune offers timely airport pickup and drop services with comfortable rides, ensuring stress-free travel to and from Pune Airport."
  },
  {
    "title": "Outstation Cab Service from Pune",
    "description": "Trusted outstation cab service from Pune covers destinations like Mumbai, Goa, Nashik, Shirdi, and Mahabaleshwar with safe long-distance travel and experienced drivers."
  },
  {
    "title": "Corporate Cab Service Pune",
    "description": "Professional cab service in Pune for corporate travel, business meetings, and employee transport ensures punctuality, comfort, and reliable service standards."
  },
  {
    "title": "Family Travel Cab Service Pune",
    "description": "Spacious vehicles like Innova, Ertiga, and Tempo Traveller are available for family travel in Pune, making group journeys safe and comfortable."
  },
  {
    "title": "One Way Cab Service Pune",
    "description": "Best cab service in Pune offers affordable one-way travel options for intercity trips without return charges, making long-distance travel budget-friendly."
  },
  {
    "title": "Hourly Cab Rental Pune",
    "description": "Flexible hourly cab service in Pune allows customers to travel across multiple locations for meetings, events, or shopping with convenient time-based pricing."
  },
  {
    "title": "Luxury Cab Service Pune",
    "description": "Premium cab service in Pune includes luxury cars for weddings, VIP travel, and special occasions with high comfort and professional chauffeurs."
  },
  {
    "title": "Trusted Taxi Service Pune",
    "description": "Best cab service in Pune is known for safety, punctuality, and well-maintained vehicles, making it a preferred choice for thousands of daily commuters."
  }
],



services: [
  {
    name: "Best Cab Service in Pune",
    description: "Best cab service in Pune provides reliable transportation for local travel, airport transfers, corporate trips, and outstation journeys. Comfortable vehicles with experienced drivers ensure safe and smooth travel for families, tourists, and business travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Vehicles include sedan cars, SUVs, Innova Crysta, Ertiga, and luxury vehicles suitable for different travel needs. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Top Cab Service Pune",
    description: "Top cab service Pune offers dependable transportation solutions for city travel and long-distance journeys with well-maintained vehicles and professional chauffeurs. Vehicles provide comfortable seating and smooth ride quality suitable for airport transfers, business travel, and tourism trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airports. Flexible booking options allow convenient travel planning."
  },
  {
    name: "Reliable Cab Service Pune",
    description: "Reliable cab service Pune provides trusted transportation for passengers traveling within Pune and nearby destinations. Comfortable vehicles ensure smooth city and highway travel experience for individuals, families, and corporate travelers. Professional drivers ensure safe driving and timely pickup services across Pune. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient local and outstation cab reservations."
  },
  {
    name: "Affordable Cab Service Pune",
    description: "Affordable cab service Pune offers budget-friendly transportation for local travel, airport transfers, and outstation journeys. Comfortable vehicles provide reliable travel experience while maintaining economical pricing for passengers. Professional drivers ensure safe journeys and punctual pickup services throughout Pune and nearby destinations. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Flexible booking options allow convenient and cost-effective travel planning."
  },
  {
    name: "Trusted Cab Service Pune",
    description: "Trusted cab service Pune provides dependable transportation with experienced drivers and comfortable vehicles for city and outstation travel. Vehicles are suitable for family trips, airport transportation, and business travel requirements. Professional chauffeurs ensure punctual pickup and safe driving services for passengers. Pickup services are available across Pune including residential areas, offices, hotels, railway stations, and airports. Flexible booking options allow hassle-free cab reservations."
  },
  {
    name: "Professional Cab Service Pune",
    description: "Professional cab service Pune offers high-quality transportation for corporate travelers, tourists, and families looking for reliable travel solutions. Comfortable vehicles provide smooth city and highway travel with experienced chauffeurs ensuring passenger comfort and safety. Pickup services are available from offices, homes, hotels, railway stations, and airport terminals. Ideal for business meetings, airport transfers, and outstation trips. Flexible booking options allow convenient cab scheduling."
  },
  {
    name: "Safe Cab Service Pune",
    description: "Safe cab service Pune provides secure and comfortable transportation for passengers traveling within Pune and nearby destinations. Well-maintained vehicles and professional drivers ensure safe highway and city travel experience for passengers. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airport terminals. Ideal for solo travelers, families, corporate employees, and tourists. Flexible booking options allow convenient local and outstation travel reservations."
  },
  {
    name: "AC Cab Service Pune",
    description: "AC cab service Pune offers air-conditioned transportation for comfortable city and outstation travel across Pune. Vehicles provide spacious seating and pleasant travel experience suitable for airport transfers, business trips, and family travel. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports. Flexible booking options allow convenient AC cab reservations."
  },
  {
    name: "Luxury Cab Service Pune",
    description: "Luxury cab service Pune provides premium transportation with high-end vehicles and professional chauffeurs for comfortable travel experience. Luxury vehicles offer spacious interiors, smooth ride quality, and advanced travel comfort suitable for corporate travel, airport transfers, and tourism. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airports. Flexible booking options allow convenient luxury cab reservations."
  },
  {
    name: "Local Cab Service Pune",
    description: "Local cab service Pune offers reliable transportation for daily commutes, shopping trips, office travel, and local sightseeing within Pune city. Comfortable vehicles provide smooth city travel experience for passengers. Professional drivers ensure safe journeys and timely pickup services throughout Pune. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient local travel reservations."
  },
  {
    name: "Outstation Cab Service Pune",
    description: "Outstation cab service Pune provides dependable transportation for long-distance journeys from Pune to tourist destinations, business cities, and pilgrimage locations. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium cars suitable for comfortable highway travel. Professional drivers ensure safe driving and smooth journeys for passengers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient one-way and round-trip travel planning."
  },
  {
    name: "Corporate Cab Service Pune",
    description: "Corporate cab service Pune provides professional transportation solutions for business travelers, company employees, and corporate events. Comfortable vehicles ensure smooth city and airport travel with experienced chauffeurs maintaining punctuality and professionalism. Pickup services are available from offices, hotels, homes, railway stations, and airport terminals across Pune. Ideal for employee transportation, client meetings, and corporate travel requirements. Flexible booking options allow convenient corporate cab reservations."
  },
  {
    name: "Premium Cab Service Pune",
    description: "Premium cab service Pune offers comfortable and high-quality transportation with well-maintained vehicles and professional chauffeurs. Vehicles provide spacious seating and smooth travel experience suitable for airport transfers, business travel, and family trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, offices, hotels, railway stations, and airports. Flexible booking options allow convenient premium cab reservations."
  },
  {
    name: "Cheapest Cab Service Pune",
    description: "Cheapest cab service Pune provides economical transportation for passengers looking for affordable travel options within Pune and nearby destinations. Comfortable vehicles ensure reliable travel while maintaining budget-friendly pricing for local and outstation journeys. Professional drivers ensure safe driving and punctual pickup services across Pune. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Highly Rated Cab Pune",
    description: "Highly rated cab Pune service offers dependable transportation with comfortable vehicles and experienced drivers for city and outstation travel. Vehicles provide smooth ride quality and spacious seating suitable for airport transfers, tourism, and business trips. Professional chauffeurs ensure safe driving and timely pickup services throughout Pune and nearby destinations. Pickup services are available from homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Round Trip Cab Rental",
    description: "Round trip cab rental service provides convenient return transportation for passengers planning business travel, family visits, tourism trips, and airport journeys. Comfortable vehicles ensure smooth city and highway travel with experienced drivers offering safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for long-distance travel and outstation journeys. Flexible booking options allow convenient round-trip cab reservations."
  }
],

tableData: [
  ["Best Cab Service in Pune", "Top Cab Service Pune"],
  ["Reliable Cab Service Pune", "Affordable Cab Service Pune"],
  ["Trusted Cab Service Pune", "Professional Cab Service Pune"],
  ["Safe Cab Service Pune", "AC Cab Service Pune"],
  ["Luxury Cab Service Pune", "Local Cab Service Pune"],
  ["Outstation Cab Service Pune", "Corporate Cab Service Pune"],
  ["Premium Cab Service Pune", "Cheapest Cab Service Pune"],
  ["Highly Rated Cab Pune", "Round Trip Cab Rental"]
],



 whychoose: [
      {
        WhyChooseheading: "Trusted Cab Service in Pune",
        WhyChoosedescription: "Shivai Travels is known as one of the best cab services in Pune for providing reliable transportation with professional drivers, clean vehicles, and punctual pickup services for local and outstation travel."
      },
      {
        WhyChooseheading: "Affordable & Transparent Cab Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable cab service in Pune with transparent pricing and no hidden charges. Customers receive clear fare details before booking confirmation for stress-free travel planning."
      },
      {
        WhyChooseheading: "24/7 Taxi Service Availability",
        WhyChoosedescription: "Our Pune cab service is available 24 hours a day for airport transfers, business travel, emergency transportation, railway station pickups, and outstation journeys."
      },
      {
        WhyChooseheading: "Comfortable & Sanitized AC Vehicles",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, regularly sanitized, and well maintained to provide safe and comfortable travel experiences for passengers."
      },
      {
        WhyChooseheading: "Local & Outstation Cab Services",
        WhyChoosedescription: "Shivai Travels provides flexible cab booking options including local Pune taxi service, one-way outstation cabs, round trips, airport transfers, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for family tours, corporate travel, and group transportation."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels offers doorstep pickup services from homes, offices, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Professional & Experienced Drivers",
        WhyChoosedescription: "Our experienced drivers ensure smooth, safe, and timely travel with polite behavior, route knowledge, and professional customer service for every journey."
      }
    ]
  };

  const faqData = [
    { question: "Why is Shivai Travels considered one of the best cab services in Pune?", answer: "Shivai Travels is trusted for professional drivers, clean vehicles, affordable pricing, and reliable local and outstation taxi services." },
    { question: "Is Pune cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 cab service in Pune for airport transfers, local travel, and outstation trips." },
    { question: "Which vehicles are available for cab booking in Pune?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune?", answer: "Yes, customers can book one-way as well as round-trip taxi services from Pune." },
    { question: "Do you provide Pune Airport cab service?", answer: "Yes, Shivai Travels provides airport pickup and drop taxi services in Pune." },
    { question: "Are all taxis air-conditioned?", answer: "Yes, all taxis provided by Shivai Travels are fully air-conditioned and maintained for passenger comfort." },
    { question: "Can I book a cab online in Pune?", answer: "Yes, customers can easily book Pune cab services online or through phone booking." },
    { question: "Do you provide cabs for family and group travel?", answer: "Yes, Shivai Travels provides vehicles suitable for family tours, corporate trips, and group transportation." },
    { question: "Are the taxi fares affordable?", answer: "Yes, Shivai Travels offers affordable and transparent cab pricing without hidden charges." },
    { question: "Is advance booking available for Pune taxi service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Nitin Shinde",
      feedback:
        "One of the best cab services in Pune. Clean car, professional driver, and smooth travel experience with Shivai Travels.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Pooja Kulkarni",
      feedback:
        "Booked Pune airport cab service with Shivai Travels. Affordable pricing, punctual pickup, and excellent customer support.",
      rating: 5
    }
  ];











































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Cab Service in Pune",
  "image": "https://shivaitravels.com/assets/images/best-cab-service-pune.jpg",
  "description": "Experience the best cab service in Pune with Shivai Travels. We provide reliable, affordable, safe, and professional cab services for local travel, airport transfers, corporate rides, and outstation trips including Pune to Mumbai travel.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/best-cab-service-in-pune"
  }
};









  return (
    <div>
<Helmet>
  <title>Best Cab Service in Pune | Reliable & Affordable Taxi Service | +91 9689815477</title>

  <meta
    name="description"
    content="Book the best cab service in Pune for local travel, airport transfers, corporate rides, and outstation trips. Affordable, safe, AC, luxury, and professional taxi services available 24x7."
  />

  <meta
    name="keywords"
    content="Best cab service in pune, top cab service pune, reliable cab service pune, affordable cab service pune, trusted cab service pune, professional cab service pune, safe cab service pune, ac cab service pune, luxury cab service pune, local cab service pune, outstation cab service pune, corporate cab service pune, premium cab service pune, cheapest cab service pune, highly rated cab pune, best cab service in pune, best cab service pune to mumbai, best outstation cab service in pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/4.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bestcabserviceinpune;